import { ActionReducerMap } from '@ngrx/store';
import { InjectionToken } from '@angular/core';

import { OpsOrderModel } from '../models/order.ops';
import { ReducerForCollection } from './reducers';

export const OPS_ORDER_COLLECTION = 'opsOrders';
export const OPS_COMPLETED_ORDER_COLLECTION = 'opsCompletedOrders';
/**
 * Interface representing application storage tree
 */
export interface AppState {
  opsOrders: CollectionState<OpsOrderModel>;
  opsCompletedOrders: CollectionState<OpsOrderModel>;
}

/**
 * Interface for a normalized storage of a list of entities
 */
export interface CollectionState<T> {
  ids: string[];
  entities: { [uid: string]: T };
  total_result: number;
  total_pages: number;
  loaded: boolean;
  loading: boolean;
}

export const reducers: ActionReducerMap<AppState> = {
  opsOrders: ReducerForCollection(OPS_ORDER_COLLECTION),
  opsCompletedOrders: ReducerForCollection(OPS_COMPLETED_ORDER_COLLECTION),
};

/**
 * Make reducers injectable. This is necessary for AOT.
 */
export const reducerToken = new InjectionToken<ActionReducerMap<AppState>>(
  'Registered Reducers'
);
export const reducerProvider = [{ provide: reducerToken, useValue: reducers }];

/**
 * Creates an empty CollectionState object
 * @returns CollectionState
 */
export function createCollectionState<T>(): CollectionState<T> {
  return {
    ids: [],
    entities: {},
    loading: true,
    loaded: false,
    total_pages: 0,
    total_result: 0,
  };
}

/**
 * Maps a collection state object to an ordered array of entities
 * @param  {CollectionState<T>} collectionState
 * @returns T[] - An ordered array of entities
 */
export function getAll<T>(collectionState: CollectionState<T>): T[] {
  let list = collectionState.ids.map(id => collectionState.entities[id]);
  return list;
}

/**
 * Selects a single entity by unique id
 * @param  {string} id - id of entity to select
 * @param  {CollectionState<T>} collectionState
 * @returns T - A single entity
 */
export function getById<T>(id: string, collectionState: CollectionState<T>): T {
  let obj = collectionState.entities[id];
  return obj;
}



// WEBPACK FOOTER //
// ./src/state/state.ts